module.exports = __webpack_public_path__ + "media/images/wakatta-icon_on-311de3ed1ab0f85deb53e61312210dcd.png";